import { computed, defineComponent } from "vue";
import { DropdownHelper, DropdownItem, HeaderMenuItem, fmtMsg } from "vue-glcommonui";
import { HelpMenuLocal } from "@/locales/localeid";
import { isRussiaDomain } from "@/utils/tenant";

interface HelpMenuItem {
  textLocaleId: string;
  url?: string;
  color: string;
}

export default defineComponent({
  components: {
    DropdownItem,
    DropdownHelper,
    HeaderMenuItem,
  },
  setup() {
    const displayedHelpMenu: HelpMenuItem[] = [
      {
        textLocaleId: HelpMenuLocal.Contact,
        url: process.env.VUE_APP_HELP_URL,
        color: "#5c2d91",
      },
      {
        textLocaleId: HelpMenuLocal.Documentation,
        url: `https://help.grapeseed.${isRussiaDomain() ? "ru" : "com"}/gl/region-index.html`,
        color: "#5c2d91",
      },
    ];
    const helpText = computed(() => fmtMsg(HelpMenuLocal.Help));
    return {
      displayedHelpMenu,
      fmtMsg,
      helpText,
    };
  },
});
